import { render, staticRenderFns } from "./VisibilityChip.vue?vue&type=template&id=060e267f"
import script from "./VisibilityChip.vue?vue&type=script&lang=js"
export * from "./VisibilityChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports